import React, { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter, HashRouter } from 'react-router';
import { AppRouter } from './router';
import container from './lib/di/container';
import ConfigRepo from './core/repos/config.repo';
import { App } from 'antd';

const configRepo = container.get(ConfigRepo);
configRepo.getConfigs();

function isStandalone() {
  return window.matchMedia('(display-mode: standalone)').matches
    ? true
    : false
}

function EntryComponent() {
  return (
    <App>
      {
        isStandalone()
        ?<HashRouter>
          <AppRouter></AppRouter>
        </HashRouter>
        :<BrowserRouter>
          <AppRouter></AppRouter>
        </BrowserRouter>
      }
    </App>
  );
}

export default EntryComponent;
